module.exports = __webpack_public_path__ + "img/default.36b1d528.jpg";